import React, { useEffect, useState } from 'react';
import './Internetconnection.css';
import { useNetworkStatus } from './NetworkProvider';

function Internetconnection() {
  const { isOnline } = useNetworkStatus();
  const [showBanner, setShowBanner] = useState(false);
  const [prevStatusInternet, setPrevStatusInternet] = useState(isOnline);

useEffect(() => {
  let timer;

  if (isOnline !== prevStatusInternet) {
    setPrevStatusInternet(isOnline);
    setShowBanner(true);

    timer = setTimeout(() => {
      setShowBanner(false);
    }, 2000);
  }

  return () => {
    if (timer) clearTimeout(timer);
  };
}, [isOnline]);


  return (
    <>
      {!isOnline ? (
        <div className="internet-connection-banner offline">
          <div className="banner-content">
            <span className="banner-icon">📶</span>
            <p>You are offline. Please check your internet connection.</p>
          </div>
        </div>
      ) : showBanner ? (
        <div className="internet-connection-banner online">
          <div className="banner-content">
            <span className="banner-icon">✅</span>
            <p>You are back online!</p>
          </div>
        </div>
      ) : null}
    
    </>
  );
}

export default Internetconnection;
